import { newGuid } from '@app/helpers/geradorGuid';
import { hasPermission } from '@app/helpers/permissions';
import React, { Fragment, memo } from 'react'

interface IProps {
    children: React.ReactNode | undefined;
    visible?: boolean;
    permissions?: string[];
    isGridView?: boolean;
    isFragment?: boolean;
    visibilityKey?: string;
}

export const Visibility = ({
    children,
    visible = true,
    permissions,
    isGridView,
    isFragment = true,
    visibilityKey,
}: IProps): any => {
    // console.log('Visibility', {
    //     visible,
    //     permissions,
    //     isGridView,
    //     isFragment,
    //     visibilityKey,
    // });

    if (isGridView && !visible) {
        return (() => { });
    }

    if (!visible) {
        return <Fragment key={visibilityKey}></Fragment>;
    }

    let isPermited = permissions && permissions.length > 0 && hasPermission(permissions);

    if (isPermited == false) {
        return <Fragment key={visibilityKey}></Fragment>;
    }

    return (isFragment == false || isGridView)
        ? children
        : <Fragment key={visibilityKey}>{children}</Fragment>;
}

export const VisibilityMemo = memo(Visibility);


export function callbackVisibility({
    permissions,
    children,
    visible = true,
    isGridView = false,
}: IProps) {
    return (permissions && hasPermission(permissions)) && visible ? (
        children
    ) : isGridView ? (
        () => { }
    ) : <></>
}